import { createFileRoute, redirect } from "@tanstack/react-router";

// Backward-compat redirect for stale Figma plugin builds that still load
// `${origin}/plugin`. Tear out after a release window once the plugin has
// been republished with `${origin}/plugin/figma` baked in.
export const Route = createFileRoute("/plugin/")({
  beforeLoad: () => {
    throw redirect({ to: "/plugin/figma", replace: true });
  },
});
